<header class="footer-page-header">
  <div class="header-container">
    <div class="logo-section">
      <div class="logo-container" (click)="navigateToHome()">
        <img src="../../../../../assets/images/logo-t.png" alt="HPS Life Logo" class="logo-img">
      </div>
    </div>
    <div class="nav-links">
      <a class="nav-link" (click)="navigateToLogin()">MAKE A CLAIM</a>
      <a (click)="scrollToSection('footer')" class="nav-link">ABOUT</a>
      <a (click)="scrollToSection('services')" class="nav-link">SERVICES</a>
    </div>
  </div>
</header>